import { NewsDetails } from "@/@types"
import { ROUTES } from "@/config/routes";
import Link from "next/link";
import IconSprite from "../common/IconSprite";
import NewsDateFormatter from "@/helpers/dates/NewsDateFormatter";
import Image from "next/image";

type Props = {
    NewestNews?: NewsDetails | null;
}

export default function NewsNewestCard({ NewestNews }: Props) {
    if (!NewestNews) {
        return null;
    }

    const formatDate = NewsDateFormatter(NewestNews.date);

    return (
        <Link
            href={ROUTES.news.details(NewestNews.category.slug, NewestNews.slug)}
            className="block"
        >
            <div className="flex flex-col md:flex-row bg-white overflow-hidden mt-8">
                <div className="md:w-1/2 aspect-video p-4">
                    <Image
                        width={550}
                        height={275}
                        src={NewestNews.image}
                        alt={NewestNews.title}
                        className="h-full w-full object-cover"
                        quality={65}
                        loading="eager"
                        unoptimized={false}
                        sizes="(max-width: 768px) 100vw, 550px"
                    />
                </div>
                <div className="md:w-1/2 p-6 flex flex-col justify-between">
                    <div>
                        <p className="text-sm bg-black text-white inline-block px-3 py-1 mb-4 w-fit">
                            {NewestNews.category.name}
                        </p>

                        <h2 className="text-2xl font-bold text-gray-800 mb-4">
                            {NewestNews.title}
                        </h2>
                        <p
                            className="text-gray-600 mb-4"
                            dangerouslySetInnerHTML={{
                                __html: NewestNews.description ||
                                    (NewestNews.longDescription ? NewestNews.longDescription.substring(0, 150) + "..." : "")
                            }}
                        />
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t border-gray-300">
                        <p className="text-dark01">
                            {formatDate}
                        </p>

                        <span
                            className="text-dark01 hover:bg-light01 font-bold text-sm flex items-center gap-1"
                        >
                            {`SEGUIR LEYENDO `}
                            <IconSprite id="ic_arrow_right" className="w-3 h-3" />
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    )
}
